"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSL = void 0;
function viewSL(props) {
    return {
        constructor: function (props) {
            props.sections.forEach(function (section) {
                if (section.minimumEntries > 0 && section.entries.length < section.minimumEntries) {
                    var additionalEntries = section.minimumEntries - section.entries.length;
                    for (var i = 0; i < additionalEntries; i++) {
                        props.onAddEntry(section.sectionId);
                    }
                }
                section.entries.slice(0, section.minimumEntries).forEach(function (e) { return e.hideDelete = true; });
            });
        },
        events: {
            onChange: this.props.onChange,
            onChangeNoId: this.props.onChangeNoId,
            onChangeDate: this.props.onChangeDate,
            onChangeDaterange: this.props.onChangeDaterange,
            onAddEntry: this.props.onAddEntry,
            onEntryDeleted: this.props.onEntryDeleted
        }
    };
}
exports.viewSL = viewSL;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/.tmp/ApplicationRendererSection/ViewSL.js
// module id = 311
// module chunks = 0 1